import Vue from 'vue'
import App from './App.vue'

import 'normalize.css/normalize.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/icon.css'
import '@/assets/element-variables.scss'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import store from './store'
import router from './router'

// 引入echarts
import * as echarts from 'echarts'
import {getToken, setToken, removeToken} from '@/utils/auth'

import '@/permission'
import '@antv/x6-vue-shape'

Vue.prototype.$echarts = echarts;


Vue.use(ElementUI);
Vue.use(VueQuillEditor);
import "@/assets/common.scss";
Vue.config.productionTip = false;

new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})



